<template>
  <div class="user-card" @click="()=>$router.push(`/profile/${user.id}`)">
    <div class="border-bottom">
      <div class="pa-4 d-flex align-center">
        <v-avatar v-if="user.profile_image" class="mr-3"
          ><img :src="user.profile_image"
        /></v-avatar>
        <v-avatar v-else class="mr-3"
          ><img src="/images/default-profile.jpg"
        /></v-avatar>
        <div>
          <h4 class="ma-0">{{ user.firstname }} {{ user.lastname }}</h4>
          <small
            ><v-chip
              x-small
              class="mr-1"
              v-for="type of user.creator_type"
              :key="type"
              >{{ type }}</v-chip
            ></small
          >
        </div>
      </div>
    </div>
    <div class="d-flex align-center border-bottom">
      <!-- <div class="mutual-friends pa-4">
        <v-avatar class="mutual-friend" size="16"></v-avatar>
        <v-avatar class="mutual-friend" size="16"></v-avatar>
        <v-avatar class="mutual-friend" size="16"></v-avatar>
      </div> -->
      <v-chip small class="ml-6 my-2"
        >{{ user.connects.length }} Connects</v-chip
      >
    </div>
    <!-- <div class="d-flex pa-4">
      <span v-if="isFriend(user.id)" class="ml-auto">
        <v-btn
          small
          color="green white--text"
          class="mr-3"
          :to="'/messages?user=' + user.id"
          >Message</v-btn
        >
        <v-btn small color="primary" @click="lc_disconnect">Disconnect</v-btn>
      </span>
      <span
        v-else-if="isRequestSent(user.id)"
        @click="lc_cancel_request"
        class="ml-auto"
      >
        <v-btn small color="primary">Cancel Request</v-btn>
      </span>
      <span v-else-if="isRequestRecived(user.id)" class="ml-auto">
        <v-btn small color="primary" @click="lc_accept_request">Accept</v-btn>
        <v-btn
          small
          color="red white--text"
          class="ml-3"
          @click="lc_reject_request"
          >Reject</v-btn
        >
      </span>
      <span v-else class="ml-auto" @click="lc_connect">
        <v-btn small color="primary">Connect</v-btn>
      </span>
    </div> -->
    <div class="pa-4">
      <request-system :user="user" />
    </div>
  </div>
</template>

<script>
import RequestSystem from "../RequestSystem.vue";
export default {
  components: { RequestSystem },
  name: "UserCard",
  props: ["user"],
  methods: {},
};
</script>

<style scoped>
.user-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.mutual-friends {
  position: relative;
  height: 25px;
}
.mutual-friend {
  border: 1px solid #fff;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
.mutual-friend:nth-child(1) {
  left: 5px;
  background: orange;
}
.mutual-friend:nth-child(2) {
  left: 10px;
  background: yellow;
}
.mutual-friend:nth-child(3) {
  left: 15px;
  background: red;
}
</style>